// 中医体质辨识（商业版）模块
// 依赖：tizhi_content 已在 pipeline.parseBase 中完成 JSON.parse
export default function transform(data) {
    if (data && data.tizhi_content) {
        data.jibing = data.tizhi_content.jibing || {};
    }
}
